import React from "react";
import { useDispatch } from "react-redux";
import { UPDATE_FIXED_TP, UPDATE_FIXED_TSL } from "../../../../actions/create-bot-type";
import { isLong } from "../../../../utils/Utils";

const FixedTP = (props) => {
  const { newBot } = props;
  const tps = newBot.fixedTP;
  const long  = isLong(newBot.strategy)
  const dispatch = useDispatch();
  if (!tps) {
    updateTrailingTP({ triggerAt: 2, stopAt: 1 });
  }
  const updateTrailingTP = (tps) => {
    dispatch({
      type: UPDATE_FIXED_TP,
      payload: tps,
    });
  };
  const trailing = tps || { triggerAt: 2, stopAt: 1 };
  const changeStopAt = (val) => {
    if(val<=100){
      updateTrailingTP({
        triggerAt: trailing.triggerAt,
        stopAt: val,
      });
    }
    
  };
  const changeTriggerAt = (val) => {
    updateTrailingTP({
      triggerAt: val,
      stopAt: trailing.stopAt,
    });
  };
  return (
    <div>
      <div className="trailing-item">
       {long?"Sell":"Buy"} {" "}
        <input
          type="number"
          style={{ width: 50 }}
          value={trailing.stopAt}
          onChange={(e) => changeStopAt(e.target.value)}
          min={0}
        />
        % of asset at every{" "}
        <input
          type="number"
          style={{ width: 50 }}
          value={trailing.triggerAt}
          onChange={(e) => changeTriggerAt(e.target.value)}
          min={0}
        />
        % {long?"above":"below"} {long?"Buy":"Sell"} Price
      </div>
    </div>
  );
};

export default FixedTP;
